export default __webpack_public_path__ + "static/media/admission2526.4c524dba.png";